import { parseFilterSafely } from "utils/utils";

export const getCustomFiltersFromUrl = (queryParams: { [key: string]: string }) => {
    const customFilter = queryParams.customFilter;
    return customFilter ? parseFilterSafely(customFilter) : {};
};

export const addCustomFilterMutator = (args, state, utils) => {
    utils.changeValue(state, "customFilter", () => args[0]);
};
export const validateCustomFilter = (values, errors) => {
    if (values._hasNestedValidationErrors) {
        errors.customFilter = "Custom filter validation errors";
    }
};
